import { Routes } from '@angular/router';
import { CustomOktaAuthGuard } from './core/guards/custom-okta-auth.guard';
import { AuthCallbackComponent } from './components/shared/okta/okta-callback.component';
import { LogoutComponent } from './logout/logout.component';

export const rootRouterConfig: Routes = [
  {
    path: 'auth/callback',
    component: AuthCallbackComponent,
    title: 'Authentication Callback'
  },

  {
    path: 'logout',
    component: LogoutComponent,
    title: 'Logout'
  },

  {
    path: '',
    title: 'DataDrop',
    pathMatch: 'full',
    redirectTo: 'file-explorer',
  },

  {
    path: 'file-explorer',
    title: 'DataDrop - File Explorer',
    canActivate: [CustomOktaAuthGuard],
    loadChildren: () =>
      import('./feature-file-explorer/file-explorer.module').then(
        (m) => m.FileExplorerModule,
      ),
  },
  {
    path: 'recipe',
    title: 'DataDrop - Recipe',
    canActivate: [CustomOktaAuthGuard],
    loadChildren: () =>
      import('./feature-recipe/recipe.module').then((m) => m.MergeModule),
  },
  {
    path: 'customer',
    title: 'DataDrop - Customer',
    canActivate: [CustomOktaAuthGuard],
    loadChildren: () =>
      import('./customer/customer.module').then((m) => m.CustomerModule),
  },
  {
    path: 'dataset',
    title: 'DataDrop - Dataset',
    canActivate: [CustomOktaAuthGuard],
    loadChildren: () =>
      import('./dataset/dataset.module').then((m) => m.DatasetModule),
  },

  {
    path: 'reports',
    title: 'DataDrop - Reports',
    canActivate: [CustomOktaAuthGuard],
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'storage/raw-upload',
    title: 'DataDrop - Upload to Raw',
    canActivate: [CustomOktaAuthGuard],
    loadChildren: () =>
      import('./feature-raw-upload/raw-upload.module').then(
        (m) => m.RawUploadModule,
      ),
  },
  {
    path: 'harmonized-explorer',
    title: 'DataDrop - Harmonized Explorer',
    canActivate: [CustomOktaAuthGuard],
    loadChildren: () =>
      import('./feature-harmonized-explorer/harmonized-explorer.module').then(
        (m) => m.HarmonizedExplorerModule,
      ),
  },
  {
    path: '**',
    title: 'DataDrop',
    redirectTo: 'file-explorer',
  },
];
